import { Injectable } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { MsalService } from '@azure/msal-angular';
import { AuthenticationResult } from '@azure/msal-browser';
import { environment } from '../../environments/environment';
import { AuthModel } from '../pages/models/auth.models';
import { protectedResources } from '../auth-config';
import { MenuService } from '../pages/layout-component/services/menu.service';



@Injectable({
  providedIn: 'root',
})
export class AuthService {

  authModel: AuthModel | undefined;
  private accessTokenExpirationTimer: any;
  private refreshTokenExpirationTimer: any;

  constructor(private http: HttpClient, public service: MenuService,
    private msalService: MsalService) { }

  setAccessTokenExpirationTimer(expirationDuration: number) {
    this.accessTokenExpirationTimer = setTimeout(() => {
      this.logout();
    }, expirationDuration);
  }

  setRefreshTokenExpirationTimer(expirationDuration: number) {
    this.refreshTokenExpirationTimer = setTimeout(() => {
      // Perform refresh token logic here, such as refreshing the token and updating the timers.
    }, expirationDuration);
  }

  clearTokenExpirationTimers() {
    if (this.accessTokenExpirationTimer) {
      clearTimeout(this.accessTokenExpirationTimer);
      this.accessTokenExpirationTimer = null;
    }
    if (this.refreshTokenExpirationTimer) {
      clearTimeout(this.refreshTokenExpirationTimer);
      this.refreshTokenExpirationTimer = null;
    }
  }

  checkTokenExpiration() {

    const tokenModel = sessionStorage.getItem("tokenModel");
    let obj = null;
    if (tokenModel !== null) {
      obj = JSON.parse(tokenModel);
    }


    if (obj !== null) {
      this.authModel = obj;

      const accessToken = this.authModel?.Token;
      const refreshToken = this.authModel?.RefreshToken;
      if (!accessToken || !refreshToken) {
        this.logout();
      } else {
        const accessTokenExpirationDate = new Date(this.authModel?.ExpiresOn != null ? this.authModel?.ExpiresOn : new Date());
        const refreshTokenExpirationDate = new Date(this.authModel?.RefreshTokenExpiration != null ? this.authModel?.RefreshTokenExpiration : new Date());
        if (accessTokenExpirationDate !== undefined && refreshTokenExpirationDate !== undefined) {
          const accessTokenExpiresIn = accessTokenExpirationDate.getTime() - new Date().getTime();
          const refreshTokenExpiresIn = refreshTokenExpirationDate.getTime() - new Date().getTime();
          if ((accessTokenExpiresIn <= 0 || refreshTokenExpiresIn <= 0)) {
           // this.logout();
          } else {
            this.setAccessTokenExpirationTimer(accessTokenExpiresIn);
            this.setRefreshTokenExpirationTimer(refreshTokenExpiresIn);
          }
        }
      }
    }
  }

  async logout() {
    await this.service.Logout().then((x: any) => {
      if (x == true) {
        const items: string[] = protectedResources.apiMenueList.scopes.read;
        const account = this.msalService.instance.getActiveAccount();
        if (account != null) {
          sessionStorage.removeItem('IsSetToken');
          this.msalService.instance.acquireTokenSilent({
            account: account,
            scopes: items
          })
            .then((result: AuthenticationResult) => {
              this.msalService.logout({
                postLogoutRedirectUri: environment.redirectUrlForAzure,
                idTokenHint: result.idToken
              });
            })
            .catch((error) => {
              console.log('Error acquiring token:', error);
            });

        }
      }

    })
  }

}
